<script>
  export default {
    name: 'Modale',
    props: ['title','img'],
    mounted(){
      //Que la modale récupère le focus au démarrage pour que l'évènement 'ESC' soit capté.
      this.$nextTick(() => this.$refs.focusMe.focus())
    },
    methods: {
      close() {
        this.$emit('close');
      },
    },
  };
</script>

<template>
    <transition name="modal-fade" appear="">
        <div class="modal-backdrop">
            <div class="modal">
                <header class="modal-header">
                    <slot name="header">
                      <div v-if="title"> {{title}} </div>
                      <div v-else>Fonctionnalité à ajouter</div>
                    </slot>
                    <!-- <button type="button" class="btn-close" @click="close">x</button> -->
                    <span class="material-icons" @click="close()" tabindex="0" @keydown.esc="close()" ref='focusMe'>close</span>
                </header>
                <div class="box">
                  <!-- <img src="../assets/help.jpg"> -->
                  <img :src="img" alt="Image absente" v-if="img">
                  <div class="box__content">
                    <section class="modal-body">
                            <slot name="body">
                              Cette Fonctionnalité n'a pas encore été implémentée.<br>Encore un peu de patience... !
                            </slot>
                            <div class="modal-dev-notes">
                              <slot name="dev-notes">
                                <!-- Pas de dev notes par défaut -->
                              </slot>
                            </div>
                    </section>
                  </div>
                </div>
                <footer class="modal-footer">
                  <slot name="footer">
                    <input type="button" class="modal-footer__bouton" @click="close" value="Fermer"/>
                  </slot>
                </footer> 
            </div>
        </div>
    </transition>
</template>

<style lang="scss">
@import '../assets/main.scss';

  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 90;
  }

  .modal {
    background: #FFFFFF;
    box-shadow: 1px 1px 10px 2px rgba(50, 50,50, 0.5);
    border-radius: 5px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    padding: 25px;
    width: 500px;
    z-index: 100;
  }

  .modal-header {
    @include myFont;
    font-weight: 600;
    font-size: 18px;
    color: $main;
    display: flex;
    justify-content: space-between;

    & *{
      color: $main;
    }
  }

  .box{
    display: flex;

    & img{
      min-width: 150px;
      max-width: 150px;
      margin: 20px 25px 0 0;
      min-height: 150px;
      max-height: 150px;
    }

    &__content{
      display: flex;
      flex-direction: column;
      width: 100%;
    }
  }

  .modal-body {
    position: relative;
    @include myFont;
    font-size: 13px;
    color: $black-bolder;
    margin: 15px 0 0px 0;
    display: flex;
    flex-direction: column;
    flex: 1;

    & p{
      margin: 10px 0 0 0;
    }
  }

  .modal-dev-notes {
    position: relative;
    @include myFont;
    margin: 15px 0 10px 0;
    color: rgba(50, 50,50, 0.5);
  }

  .modal-footer {
    display: flex;
    justify-content: center;

    &__bouton{
      @include myButton;
    }
  }




  .modal-fade-enter,
  .modal-fade-leave-to {
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity 0.3s ease
  }

// --------------------------------
//      Wrappers & contents
// --------------------------------

#newMdpWrapper{

  & input{
    border-width: 0 0 1px 0;  
    width: 250px;

    &:nth-child(1){
      margin-bottom: 10px;
    }
  }

  & .erreur{
    color: $alert;
    font-size: 12px;
    height: 13px;
    margin: 2px 0 0 0;
  }
}

</style>